import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ProductCard({ item }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  // 1. Construct the media list dynamically
  const mediaList = [];

  if (+item.isVideo === 1 && item.video_link) {
    mediaList.push({ type: "video", src: item.video_link });
  }

  if (Array.isArray(item.images) && item.images.length > 0) {
    item.images.forEach((img) => mediaList.push({ type: "image", src: img }));
  } else if (item.image) {
    mediaList.push({ type: "image", src: item.image });
  }

  // 2. Navigation Handlers
  const nextSlide = (e) => {
    e.preventDefault();
    setCurrentSlide((prev) => (prev === mediaList.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = (e) => {
    e.preventDefault();
    setCurrentSlide((prev) => (prev === 0 ? mediaList.length - 1 : prev - 1));
  };

  return (
    <div className="group relative">
      <div className="relative overflow-hidden mb-4 bg-white aspect-[4/5]">
        
        {/* Badge */}
        <span className="absolute top-2 left-2 bg-[#551756] text-white text-[10px] uppercase font-bold px-2 py-1 z-20">
          {/* Trending */}
        </span>

        {/* --- MEDIA RENDERER --- */}
        <div className="w-full h-full relative">
          {mediaList.map((media, index) => (
            <div
              key={index}
              className={`absolute inset-0 w-full h-full transition-opacity duration-500 ease-in-out ${
                index === currentSlide ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
            >
              {media.type === "video" ? (
                <video
                  src={media.src}
                  className="w-full h-full object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              ) : (
                <img
                  src={media.src}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              )}
            </div>
          ))}
        </div>

        {/* --- SLIDER CONTROLS --- */}
        {mediaList.length > 1 && (
          <>
            <button
              onClick={prevSlide}
              className="absolute left-2 top-1/2 -translate-y-1/2 z-20 bg-white/80 p-1.5 rounded-full text-[#551756] opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#CAB273]"
            >
              <ChevronLeft size={16} />
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-2 top-1/2 -translate-y-1/2 z-20 bg-white/80 p-1.5 rounded-full text-[#551756] opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#CAB273]"
            >
              <ChevronRight size={16} />
            </button>
            
            {/* Pagination Dots */}
            <div className="absolute bottom-16 left-0 right-0 z-20 flex justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                {mediaList.map((_, idx) => (
                    <div 
                        key={idx} 
                        className={`w-1.5 h-1.5 rounded-full ${idx === currentSlide ? 'bg-[#CAB273]' : 'bg-white/60'}`} 
                    />
                ))}
            </div>
          </>
        )}

        {/* --- ACTION BUTTONS (DETAILS & BUY NOW) --- */}
        <div className="absolute bottom-0 left-0 w-full flex translate-y-full group-hover:translate-y-0 transition-transform duration-300 z-30">
            
            {/* DETAILS BUTTON (Left Side - Dark) */}
            <Link
                to={`/product/${item.id}`} // Change this route to match your details page
                className="w-1/2 bg-[#551756] text-white py-4 text-xs uppercase tracking-widest font-bold text-center hover:bg-[#3f1140] transition-colors"
            >
                Details
            </Link>

            {/* BUY NOW BUTTON (Right Side - Gold) */}
            <Link
                to={item.pay_link}
                className="w-1/2 bg-[#CAB273] text-[#551756] py-4 text-xs uppercase tracking-widest font-bold text-center hover:bg-[#b89f60] transition-colors"
            >
                Buy Now
            </Link>
            
        </div>
      </div>

      {/* --- INFO --- */}
      <h3 className="font-serif text-lg text-[#551756] leading-tight">
        {item.title}
      </h3>
      <p className="text-[#551756]/70 mt-1 font-medium">
        {/* If price exists, show it, otherwise show a fallback */}
        {item.price ? `₹${item.price}` : 'Free'}
      </p>
    </div>
  );
}